var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSolutionImage4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 462.337,
    height: 462.546,
    viewBox: "0 0 462.337 462.546",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4134",
    "data-name": "Rectangle 4134",
    width: 392,
    height: 390,
    rx: 13,
    transform: "translate(255 7877)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14567",
    "data-name": "Group 14567",
    transform: "translate(-249.837 -7899.227)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14493",
    "data-name": "Group 14493",
    transform: "translate(615.443 8144.227) rotate(90)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3088",
    "data-name": "Ellipse 3088",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3508",
    "data-name": "Ellipse 3508",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 12.87)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2834",
    "data-name": "Ellipse 2834",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3548",
    "data-name": "Ellipse 3548",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 12.87)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3090",
    "data-name": "Ellipse 3090",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3509",
    "data-name": "Ellipse 3509",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 12.87)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2836",
    "data-name": "Ellipse 2836",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3549",
    "data-name": "Ellipse 3549",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 12.87)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2837",
    "data-name": "Ellipse 2837",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3595",
    "data-name": "Ellipse 3595",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 12.87)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3092",
    "data-name": "Ellipse 3092",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3510",
    "data-name": "Ellipse 3510",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 12.87)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2838",
    "data-name": "Ellipse 2838",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3550",
    "data-name": "Ellipse 3550",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 12.87)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3094",
    "data-name": "Ellipse 3094",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3511",
    "data-name": "Ellipse 3511",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 12.87)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2840",
    "data-name": "Ellipse 2840",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3551",
    "data-name": "Ellipse 3551",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 12.87)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2841",
    "data-name": "Ellipse 2841",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3552",
    "data-name": "Ellipse 3552",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 12.87)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3096",
    "data-name": "Ellipse 3096",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3512",
    "data-name": "Ellipse 3512",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 12.87)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2842",
    "data-name": "Ellipse 2842",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3553",
    "data-name": "Ellipse 3553",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 12.87)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3098",
    "data-name": "Ellipse 3098",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3513",
    "data-name": "Ellipse 3513",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 12.87)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2844",
    "data-name": "Ellipse 2844",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3554",
    "data-name": "Ellipse 3554",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 12.87)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2845",
    "data-name": "Ellipse 2845",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3555",
    "data-name": "Ellipse 3555",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 12.87)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2846",
    "data-name": "Ellipse 2846",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3514",
    "data-name": "Ellipse 3514",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 12.87)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2847",
    "data-name": "Ellipse 2847",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3556",
    "data-name": "Ellipse 3556",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 12.87)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2848",
    "data-name": "Ellipse 2848",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3515",
    "data-name": "Ellipse 3515",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 12.87)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3214",
    "data-name": "Ellipse 3214",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2974",
    "data-name": "Ellipse 2974",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3216",
    "data-name": "Ellipse 3216",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2976",
    "data-name": "Ellipse 2976",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3104",
    "data-name": "Ellipse 3104",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3516",
    "data-name": "Ellipse 3516",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 23.922)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2850",
    "data-name": "Ellipse 2850",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3557",
    "data-name": "Ellipse 3557",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 23.922)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3105",
    "data-name": "Ellipse 3105",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3517",
    "data-name": "Ellipse 3517",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 23.922)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2852",
    "data-name": "Ellipse 2852",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3558",
    "data-name": "Ellipse 3558",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 23.922)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2977",
    "data-name": "Ellipse 2977",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3218",
    "data-name": "Ellipse 3218",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2978",
    "data-name": "Ellipse 2978",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3220",
    "data-name": "Ellipse 3220",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2980",
    "data-name": "Ellipse 2980",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2853",
    "data-name": "Ellipse 2853",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3600",
    "data-name": "Ellipse 3600",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 23.922)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3107",
    "data-name": "Ellipse 3107",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3518",
    "data-name": "Ellipse 3518",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 23.922)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2854",
    "data-name": "Ellipse 2854",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3559",
    "data-name": "Ellipse 3559",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 23.922)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3108",
    "data-name": "Ellipse 3108",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3519",
    "data-name": "Ellipse 3519",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 23.922)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2856",
    "data-name": "Ellipse 2856",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3560",
    "data-name": "Ellipse 3560",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 23.922)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2981",
    "data-name": "Ellipse 2981",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3222",
    "data-name": "Ellipse 3222",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2982",
    "data-name": "Ellipse 2982",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3224",
    "data-name": "Ellipse 3224",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2984",
    "data-name": "Ellipse 2984",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2857",
    "data-name": "Ellipse 2857",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3561",
    "data-name": "Ellipse 3561",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 23.922)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3110",
    "data-name": "Ellipse 3110",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3520",
    "data-name": "Ellipse 3520",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 23.922)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2858",
    "data-name": "Ellipse 2858",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3562",
    "data-name": "Ellipse 3562",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 23.922)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3111",
    "data-name": "Ellipse 3111",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3521",
    "data-name": "Ellipse 3521",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 23.922)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2860",
    "data-name": "Ellipse 2860",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3563",
    "data-name": "Ellipse 3563",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 23.922)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2985",
    "data-name": "Ellipse 2985",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2986",
    "data-name": "Ellipse 2986",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2861",
    "data-name": "Ellipse 2861",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3564",
    "data-name": "Ellipse 3564",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 23.922)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2862",
    "data-name": "Ellipse 2862",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3522",
    "data-name": "Ellipse 3522",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 23.922)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2987",
    "data-name": "Ellipse 2987",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2988",
    "data-name": "Ellipse 2988",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2863",
    "data-name": "Ellipse 2863",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3565",
    "data-name": "Ellipse 3565",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 23.922)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2864",
    "data-name": "Ellipse 2864",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3523",
    "data-name": "Ellipse 3523",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 23.922)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3114",
    "data-name": "Ellipse 3114",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2926",
    "data-name": "Ellipse 2926",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3116",
    "data-name": "Ellipse 3116",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2928",
    "data-name": "Ellipse 2928",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2929",
    "data-name": "Ellipse 2929",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3121",
    "data-name": "Ellipse 3121",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2930",
    "data-name": "Ellipse 2930",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3123",
    "data-name": "Ellipse 3123",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2932",
    "data-name": "Ellipse 2932",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2933",
    "data-name": "Ellipse 2933",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3128",
    "data-name": "Ellipse 3128",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2934",
    "data-name": "Ellipse 2934",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3130",
    "data-name": "Ellipse 3130",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2936",
    "data-name": "Ellipse 2936",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2937",
    "data-name": "Ellipse 2937",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2938",
    "data-name": "Ellipse 2938",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2939",
    "data-name": "Ellipse 2939",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2940",
    "data-name": "Ellipse 2940",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3140",
    "data-name": "Ellipse 3140",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3524",
    "data-name": "Ellipse 3524",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -20.286)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2942",
    "data-name": "Ellipse 2942",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3566",
    "data-name": "Ellipse 3566",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -20.286)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3142",
    "data-name": "Ellipse 3142",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3525",
    "data-name": "Ellipse 3525",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -20.286)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2944",
    "data-name": "Ellipse 2944",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3567",
    "data-name": "Ellipse 3567",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -20.286)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2946",
    "data-name": "Ellipse 2946",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3568",
    "data-name": "Ellipse 3568",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -20.286)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3149",
    "data-name": "Ellipse 3149",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3526",
    "data-name": "Ellipse 3526",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -20.286)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2948",
    "data-name": "Ellipse 2948",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3569",
    "data-name": "Ellipse 3569",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -20.286)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2949",
    "data-name": "Ellipse 2949",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3570",
    "data-name": "Ellipse 3570",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -20.286)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3154",
    "data-name": "Ellipse 3154",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3527",
    "data-name": "Ellipse 3527",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -20.286)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2950",
    "data-name": "Ellipse 2950",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3571",
    "data-name": "Ellipse 3571",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -20.286)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3156",
    "data-name": "Ellipse 3156",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3622",
    "data-name": "Ellipse 3622",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -64.241)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3528",
    "data-name": "Ellipse 3528",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -20.286)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2952",
    "data-name": "Ellipse 2952",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3572",
    "data-name": "Ellipse 3572",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -20.286)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2953",
    "data-name": "Ellipse 2953",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3573",
    "data-name": "Ellipse 3573",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -20.286)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2954",
    "data-name": "Ellipse 2954",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3529",
    "data-name": "Ellipse 3529",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -20.286)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2955",
    "data-name": "Ellipse 2955",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3574",
    "data-name": "Ellipse 3574",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -20.286)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2956",
    "data-name": "Ellipse 2956",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3530",
    "data-name": "Ellipse 3530",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -20.286)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3166",
    "data-name": "Ellipse 3166",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -64.241)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3531",
    "data-name": "Ellipse 3531",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -9.234)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2880",
    "data-name": "Ellipse 2880",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3575",
    "data-name": "Ellipse 3575",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -9.234)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3168",
    "data-name": "Ellipse 3168",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3532",
    "data-name": "Ellipse 3532",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -9.234)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2882",
    "data-name": "Ellipse 2882",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3576",
    "data-name": "Ellipse 3576",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -9.234)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2885",
    "data-name": "Ellipse 2885",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3609",
    "data-name": "Ellipse 3609",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -9.234)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3249",
    "data-name": "Ellipse 3249",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3610",
    "data-name": "Ellipse 3610",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -20.286)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3170",
    "data-name": "Ellipse 3170",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3533",
    "data-name": "Ellipse 3533",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -9.234)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3472",
    "data-name": "Ellipse 3472",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -75.548)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3534",
    "data-name": "Ellipse 3534",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2886",
    "data-name": "Ellipse 2886",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3577",
    "data-name": "Ellipse 3577",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -9.234)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3172",
    "data-name": "Ellipse 3172",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3535",
    "data-name": "Ellipse 3535",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -9.234)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2888",
    "data-name": "Ellipse 2888",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3578",
    "data-name": "Ellipse 3578",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -9.234)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2891",
    "data-name": "Ellipse 2891",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3579",
    "data-name": "Ellipse 3579",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -9.234)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3174",
    "data-name": "Ellipse 3174",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3536",
    "data-name": "Ellipse 3536",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -9.234)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2892",
    "data-name": "Ellipse 2892",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3580",
    "data-name": "Ellipse 3580",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -9.234)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3537",
    "data-name": "Ellipse 3537",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -9.234)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2894",
    "data-name": "Ellipse 2894",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3581",
    "data-name": "Ellipse 3581",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -9.234)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2897",
    "data-name": "Ellipse 2897",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3582",
    "data-name": "Ellipse 3582",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -9.234)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2898",
    "data-name": "Ellipse 2898",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3538",
    "data-name": "Ellipse 3538",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -9.234)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2900",
    "data-name": "Ellipse 2900",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3583",
    "data-name": "Ellipse 3583",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -9.234)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2901",
    "data-name": "Ellipse 2901",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3539",
    "data-name": "Ellipse 3539",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -9.234)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3182",
    "data-name": "Ellipse 3182",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3540",
    "data-name": "Ellipse 3540",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 1.818)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2903",
    "data-name": "Ellipse 2903",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3584",
    "data-name": "Ellipse 3584",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 1.818)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3184",
    "data-name": "Ellipse 3184",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3541",
    "data-name": "Ellipse 3541",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 1.818)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2905",
    "data-name": "Ellipse 2905",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3585",
    "data-name": "Ellipse 3585",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 1.818)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2908",
    "data-name": "Ellipse 2908",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3615",
    "data-name": "Ellipse 3615",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 1.818)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3186",
    "data-name": "Ellipse 3186",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3542",
    "data-name": "Ellipse 3542",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 1.818)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2909",
    "data-name": "Ellipse 2909",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3586",
    "data-name": "Ellipse 3586",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 1.818)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3188",
    "data-name": "Ellipse 3188",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3543",
    "data-name": "Ellipse 3543",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 1.818)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2911",
    "data-name": "Ellipse 2911",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3587",
    "data-name": "Ellipse 3587",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 1.818)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2914",
    "data-name": "Ellipse 2914",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3588",
    "data-name": "Ellipse 3588",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 1.818)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3190",
    "data-name": "Ellipse 3190",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3544",
    "data-name": "Ellipse 3544",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 1.818)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2915",
    "data-name": "Ellipse 2915",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3589",
    "data-name": "Ellipse 3589",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 1.818)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3192",
    "data-name": "Ellipse 3192",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3545",
    "data-name": "Ellipse 3545",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 1.818)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2917",
    "data-name": "Ellipse 2917",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3590",
    "data-name": "Ellipse 3590",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 1.818)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2920",
    "data-name": "Ellipse 2920",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3591",
    "data-name": "Ellipse 3591",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 1.818)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2921",
    "data-name": "Ellipse 2921",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3546",
    "data-name": "Ellipse 3546",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 1.818)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2923",
    "data-name": "Ellipse 2923",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3592",
    "data-name": "Ellipse 3592",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 1.818)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2924",
    "data-name": "Ellipse 2924",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3547",
    "data-name": "Ellipse 3547",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 1.818)",
    fill: "#090909"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14494",
    "data-name": "Group 14494",
    transform: "translate(277.443 7899.227) rotate(90)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3593",
    "data-name": "Ellipse 3593",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 12.87)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2835",
    "data-name": "Ellipse 2835",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3594",
    "data-name": "Ellipse 3594",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 12.87)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3595-2",
    "data-name": "Ellipse 3595",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 12.87)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2839",
    "data-name": "Ellipse 2839",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3618",
    "data-name": "Ellipse 3618",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3596",
    "data-name": "Ellipse 3596",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 12.87)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3552-2",
    "data-name": "Ellipse 3552",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 12.87)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3597",
    "data-name": "Ellipse 3597",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 12.87)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3555-2",
    "data-name": "Ellipse 3555",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 12.87)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3598",
    "data-name": "Ellipse 3598",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 23.922)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2851",
    "data-name": "Ellipse 2851",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3599",
    "data-name": "Ellipse 3599",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 23.922)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3600-2",
    "data-name": "Ellipse 3600",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 23.922)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2855",
    "data-name": "Ellipse 2855",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3619",
    "data-name": "Ellipse 3619",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3601",
    "data-name": "Ellipse 3601",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 23.922)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3561-2",
    "data-name": "Ellipse 3561",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 23.922)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3602",
    "data-name": "Ellipse 3602",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 23.922)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3564-2",
    "data-name": "Ellipse 3564",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 23.922)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3604",
    "data-name": "Ellipse 3604",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -20.286)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3605",
    "data-name": "Ellipse 3605",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -20.286)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3620",
    "data-name": "Ellipse 3620",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -20.286)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3608",
    "data-name": "Ellipse 3608",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -9.234)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3611",
    "data-name": "Ellipse 3611",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -9.234)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3621",
    "data-name": "Ellipse 3621",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -9.234)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3613",
    "data-name": "Ellipse 3613",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 1.818)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3614",
    "data-name": "Ellipse 3614",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 1.818)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3615-2",
    "data-name": "Ellipse 3615",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 1.818)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3616",
    "data-name": "Ellipse 3616",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 1.818)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3588-2",
    "data-name": "Ellipse 3588",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 1.818)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3617",
    "data-name": "Ellipse 3617",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 1.818)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3591-2",
    "data-name": "Ellipse 3591",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 1.818)",
    fill: "#090909"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_74",
    "data-name": "Mask Group 74",
    transform: "translate(27 55)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Image_214",
    "data-name": "Image 214",
    width: 409,
    height: 416,
    transform: "translate(246 7863)",
    xlinkHref: "data:image/png;base64,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"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolutionImage4);
export default __webpack_public_path__ + "static/media/solution-image-4.c112111a2f62b24c3c807ac1f70b233f.svg";
export { ForwardRef as ReactComponent };